// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDL7F-KPdV7yNxP3EY39CtMOQ8NB4RT1Rs",
  authDomain: "plattrtech-bf607.firebaseapp.com",
  projectId: "plattrtech-bf607",
  storageBucket: "plattrtech-bf607.firebasestorage.app",
  messagingSenderId: "94670863159",
  appId: "1:94670863159:web:59831ad2dfe5ddda41f8b2",
  measurementId: "G-H515X3117K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);